export const getWindowCenterPosition = (size: { width: number; height: number }) => {
	const x = window.innerWidth / 2 - size.width / 2;
	const y = window.innerHeight / 2 - size.height / 2 - 40;
	return {
		x: Math.max(x, 0),
		y: Math.max(y, 0),
	};
};

export function getMobileSize(fullScreen?: boolean): { width: number; height: number } {
	const mobiletopBarHeight = 0;
	const taskbarHeight = fullScreen ? 0 : 70;
	const marginTop = 0;
	const marginBottom = 0;
	const windowHeight = window.innerHeight;
	const usableHeight = windowHeight - mobiletopBarHeight - taskbarHeight - marginTop - marginBottom;
	return { width: window.innerWidth, height: usableHeight };
}
